import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[lcsSingleSelectPanel]',
    host: {
        'role': 'listbox',
        'class': 'lcs-single-select-panel',
        '[class.lcs-single-select-visible]': 'visible',
        '[class.lcs-single-select-hidden]': '!visible',
    },
    standalone: false
})
export class LcsSingleSelectPanelDirective {
   @Input() visible: boolean;

   constructor(public elementRef: ElementRef) {}
}
